import { Key } from '@briebug/ngrx-auto-entity';

export class SubcontractorCategory {
  @Key id?: number;
  name: string;
  delta: number;
}
